<template>
  <custom-popup
    v-model="computedValue"
    :cons="editCons"
    hide-overlay
    reloadable
    scrollable
  >
    <v-card-text class="position-relative pa-0">
      <v-card :loading="loading" tile>
        <v-row v-if="data != null" no-gutters>
          <v-col class="pa-2" cols="12" md="6">
            <div v-if="data.userinfo != null">
              <request-details :data="data.userinfo" />
            </div>
            <div v-else-if="data.bussiness != null">
              <business :request="data" />
            </div>
            <div v-else>
              <p class="text-center text-dark-50 mt-20 h3">
                کاربر هنوز پروفایل خود را تکمیل نکرده است.
              </p>
            </div>
          </v-col>

          <v-col class="pa-2" cols="12" md="6">
            <UserDetails :details="data" />
          </v-col>

          <v-col cols="12">
            <v-card :loading="loading" flat>
              <v-card-title>
                <v-spacer />
                تراکنش های کاربر
                <v-spacer />
              </v-card-title>

              <v-divider />

              <v-row no-gutters>
                <v-col class="pa-2" cols="12" md="4" sm="6">
                  <date-picker
                    v-model="tableProps.date"
                    display-format="jYYYY-jMM-jDD"
                    format="YYYY-MM-DD"
                    label="تاریخ تراکنش"
                    @input="getTransactions()"
                  />
                </v-col>
                <v-col class="pa-2" cols="12" md="4" sm="6">
                  <v-select
                    v-model="tableProps.type"
                    :items="types"
                    :menu-props="{ offsetY: true }"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نوع"
                    outlined
                    @input="getTransactions()"
                    @click:clear="clearType"
                  />
                </v-col>
                <v-col class="pa-2" cols="12" md="4" sm="6">
                  <v-text-field
                    v-model="tableProps.search"
                    append-icon="mdi-magnify"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="جستجو"
                    outlined
                    @keydown.enter="getTransactions()"
                    @click:clear="clearSearch"
                  />
                </v-col>
              </v-row>

              <v-divider />

              <v-card-text>
                <v-data-table
                  :expanded.sync="expanded"
                  :footer-props="footerProps"
                  :header-props="headerProps"
                  :headers="headers"
                  :items="transactions"
                  :loading="loading"
                  :options.sync="options"
                  :server-items-length="length"
                  class="elevation-1"
                  item-key="_id"
                >
                  <template v-slot:item.id="{ id, index }">
                    {{
                      tableProps.length * tableProps.page -
                      (tableProps.length - 1) +
                      index
                    }}
                  </template>
                  <template v-slot:item.type="{ item }">
                    <v-chip
                      v-if="!!item.type"
                      :color="$options.filters.transactionType(item.type).color"
                      label
                      outlined
                      small
                    >
                      {{ $options.filters.transactionType(item.type).label }}
                    </v-chip>
                  </template>
                  <template v-slot:item.amount.$numberDecimal="{ item }">
                    <v-chip
                      :color="
                        item.type === 'withdraw' || item.state==='decrease' ? '#F64E60' : 'rgb(27,197,189)'
                      "
                      dark
                      label
                      small
                    >
                      {{ price(item.amount.$numberDecimal) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.balanceAfter.$numberDecimal="{ item }">
                    {{ price(item.balanceAfter.$numberDecimal) }}
                  </template>
                  <template v-slot:item.serviceId="{ item }">
                    <v-chip color="#6993ff" dark label small>
                      {{ $options.filters.serviceTypeNumber(item.serviceId) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.createdAt="{ item }">
                    <div class="text-nowrap">
                      {{ persian($options.filters.onlyDate(item.createdAt)) }}
                    </div>
                  </template>
                  <template v-slot:item.description="{ item }">
                    <div class="link-wrapper" v-html="item.description" />
                  </template>
                  <template v-slot:item.time="{ item }">
                    <div class="text-nowrap">
                      {{ persian($options.filters.onlyTime(item.createdAt)) }}
                    </div>
                  </template>
                  <template v-slot:item.product.description="{ item }">
                    <v-chip
                      v-if="!!item.product && !!item.product.description"
                      color="#181c32"
                      dark
                      label
                      small
                    >
                      {{ item.product.description }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class="pa-2" cols="12">
            <user-jobs :packs="data.packs" />
          </v-col>
        </v-row>
      </v-card>
    </v-card-text>
  </custom-popup>
</template>

<script>
import RequestDetails from "@/view/pages/admin/confirm/userInfo/requestDetails";
import Business from "@/view/pages/admin/confirm/userInfo/Business";
import UserDetails from "@/view/pages/admin/confirm/userInfo/userDetails";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import UserJobs from "@/view/pages/admin/users/actions/userJobs";
import UserHistory from "@/view/pages/admin/users/actions/UserHistory";
import VoipHistory from "@/view/pages/admin/users/actions/VoipHistory";
import Meta from "@/view/pages/transactions/Meta";

export default {
  name: "Information",

  components: {
    VoipHistory,
    UserHistory,
    UserJobs,
    UserDetails,
    Business,
    RequestDetails,
  },
  props: {
    id: [String, Number],
    value: Boolean,
  },

  data() {
    return {
      queries: {
        type: "",
        userId: "",
        createdAt: "",
      },
      types: [
        { value: "online", text: "آنلاین" },
        { value: "admin", text: "توسط مدیر" },
        { value: "refund", text: "تراکنش اصلاحی" },
        { value: "agency", text: "عاملیت", disabled: true },
        { value: "withdraw", text: "برداشت" },
        { value: "deposit", text: "واریز" },
      ],
      headerProps: {
        sortByText: "نمایش بر ساس",
      },
      footerProps: {
        itemsPerPageText: "تعداد ردیف: ",
        itemsPerPageAllText: "همه",
        itemsPerPageOptions: [10, 25, 50, 100, 200, 400],
        pageText: "از",
        showCurrentPage: true,
        showFirstLastPage: true,
      },
      expanded: [],
      length: null,
      singleExpand: false,
      options: {},
      headers: [
        {
          text: "ردیف",
          value: "id",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "شناسه",
          value: "uniqueId",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "مبلغ",
          value: "amount.$numberDecimal",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "ساعت",
          value: "time",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "تاریخ",
          value: "createdAt",
          align: "center",
          class: "font-weight-bold h6",
        },
        {
          text: "توضیحات تکمیلی",
          value: "description",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "نوع تراکنش",
          value: "type",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "توضیح",
          value: "product.description",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        {
          text: "نام سرویس",
          value: "serviceId",
          align: "center",
          class: "font-weight-bold h6",
          sortable: false,
        },
        // {text: 'تعداد', value: 'count', align: 'center', class: 'font-weight-bold h6'},
        {
          text: "مانده موجودی",
          value: "balanceAfter.$numberDecimal",
          align: "center",
          class: "font-weight-bold h6",
        },
      ],

      editCons: {
        title: "مشاهده اطلاعات کاربر",
      },

      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
      },

      adminTypes: [
        { name: "online", value: "آنلاین" },
        { name: "admin", value: "توسط مدیر" },
        { name: "refund", value: "تراکنش اصلاحی" },
        { name: "agency", value: "عاملیت", disabled: true },
        { name: "withdraw", value: "برداشت" },
        { name: "deposit", value: "واریز" },
      ],
      data: [],
      showDescriptionAdmin: false,
      descriptionMessage: null,
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      url: "authRequest",
      userInfo: {},
      transactions: {},

      packs: {},
      transactionUrl: "admin/userTransaction",
      // tableProps: {
      //   search: '',
      //   length: 10,
      //   column: 'id',
      //   dir: 'desc',
      //   filters:{
      //     type: '',
      //     admin_type: null,
      //     confirmed: '',
      //     date: '',
      //   },
      // },
      loading: false,

      columnTransactions: [
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.transactions.current_page - 1;
            row = row * this.transactions.per_page;
            return row + val.row + 1;
          },
        },
        {
          name: "id",
          label: "شناسه",
          orderable: true,
        },
        {
          name: "amount",
          label: "مبلغ(﷼)",
          orderable: true,
          transform: ({ data }) => {
            return data.type === "deposit"
              ? `<span class="badge badge badge-success">${this.persian(
                  this.$options.filters.rial(data.amount)
                )}</span>`
              : `<span class="badge badge badge-danger">${this.persian(
                  this.$options.filters.rial(data.amount)
                )}</span>`;
            // return this.persian(this.$options.filters.rial(value.data.amount));
          },
        },
        {
          label: "ساعت",
          name: "time",
          orderable: true,
          transform: (val) => {
            return this.persian(
              this.$options.filters.onlyTime(val.data.updated_at)
            );
          },
        },
        {
          label: "تاریخ",
          name: "updated_at",
          orderable: true,
          transform: (val) => {
            return this.persian(
              this.$options.filters.onlyDate(val.data.updated_at)
            );
          },
        },

        {
          label: "توضیحات تکمیلی",
          name: "description",
        },
        {
          name: "admin_type",
          label: "نوع تراکنش",
          component: Meta,
          handler: this.showMessage,
          event: "showMessage",
          meta: {
            type: "adminType",
          },
        },
        // {
        //   name: 'type',
        //   label: ' نوع تراکنش',
        //   transform: (value) => {
        //     return value.data.type === 'deposit'
        //         ? `<span class="badge badge badge-success">افزایش موجودی</span>`
        //         : `<span class="badge badge badge-danger">کسر موجودی</span>`
        //   }
        // },
        {
          name: "confirmed",
          label: "وضعیت",
          transform: (value) => {
            return value.data.confirmed === true
              ? `<span class="badge-pill badge badge-info">تایید شده</span>`
              : `<span class="badge-pill badge badge-danger">تایید نشده</span>`;
          },
        },
        {
          name: "comment",
          label: "توضیح",
          component: Meta,
          meta: {
            type: "comment",
          },
        },
        {
          name: "service",
          label: "نام سرویس",
          component: Meta,
          meta: {
            type: "service",
          },
        },
        {
          name: "remainMoney",
          label: "مانده موجودی",
          transform: ({ data }) => {
            return this.persian(this.$options.filters.rial(data.remainMoney));
          },
          // component: Meta,
          // meta: {
          //   type: 'actions'
          // }
        },
      ],
    };
  },

  created() {
    this.getUserInfo();
    // this.getUserTransactions(this.transactionUrl);
    this.getTransactions();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    id() {
      this.getUserInfo();
      this.getTransactions();
    },
    options(val) {
      if (this.isFilter) {
        this.tableProps.page = val.page;
        this.tableProps.length = val.itemsPerPage;
        this.tableProps.column = val.sortBy[0] ?? "id";
        // if (!val.sortDesc[0])
        //     this.tableProps.dir = 'asc';
        // else
        //     this.tableProps.dir = 'desc';
        this.getTransactions(this.tableProps);
      }
    },
  },

  methods: {
    clearSearch() {
      this.tableProps.search = "";
      this.$nextTick(() => {
        this.getTransactions();
      });
    },
    showMessage(data) {
      this.showDescriptionAdmin = true;
      this.descriptionMessage = data.description;
    },
    gotoUsers() {
      this.$emit("goBack", true);
    },
    clearType() {
      this.tableProps.type = "";
      this.$nextTick(() => {
        this.getTransactions();
      });
    },
    getUserInfo() {
      this.loading = true;
      this.requestApiGet("user/" + this.id).then(({ data }) => {
        this.data = data;
        this.loading = false;
      });
    },

    getTransactions(query = this.tableProps) {
      this.loading = true;

      this.requestApiGet(`newWallet/transactions?userId=${this.id}`, query)
        .then(({ data }) => {
          console.log(data.data.data);
          this.transactions = data.data.data;
          this.isFilter = true;
          this.length = data.data.total;
        })
        .finally(() => (this.loading = false));
    },

    getUserTransactions(url = this.transactionUrl, params = this.tableProps) {
      // this.loading = true;
      this.$modal.showLoading();
      this.requestApiGet(`${url}/${this.id}`, params).then((response) => {
        this.transactions = response.data;
        this.$modal.hideLoading();
        this.loading = false;
      });
    },
    reloadTable(tableProps) {
      this.getUserTransactions(this.transactionUrl, tableProps);
    },
  },
};
</script>

<style scoped>
.link-wrapper >>> a {
  padding: 2px 4px;
  margin: 0 4px;
  background-color: #0d8ddc;
  border-radius: 4px;
  color: white;
  transition: background-color 0.1s ease-out;
}

.link-wrapper >>> a:hover {
  background-color: #2ea0ec;
}
</style>
